import React, { useEffect, useState } from "react";
import AppCard from "../../../shared/components/AppCard";
import { Button, Table, Modal, Popconfirm, Tooltip } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import "./scanCenterList.scss";
import ScanCenterForm from "../ScanCenterForm";
import { ScanCenter } from "../../../models/ScanCenter/scanCenter.model";
import ScanCenterService from "../../../services/ScanCenter/scanCenter.service";
import { PlusOutlined } from "@ant-design/icons";
import AppLoader from "../../../shared/components/AppLoader";
import { generatePath, Link } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import { AdminTypeEnum } from "../../../enums/AdminType.enum";

interface ScanCenterListProps extends AuthReducerProps {}

function ScanCenterList({ adminType }: ScanCenterListProps) {
  const [scanCenters, setScanCenters] = useState<ScanCenter[]>([]);

  const [showScanCenterForm, setShowScanCenterForm] = useState(false);

  const [loading, setLoading] = useState(false);

  const [activeScanCenter, setActiveScanCenter] = useState<ScanCenter>(
    new ScanCenter()
  );

  const handleCloseScanCenterForm = () => setShowScanCenterForm(false);

  const handleAddScanCenter = () => {
    setActiveScanCenter(new ScanCenter());
    setShowScanCenterForm(true);
  };

  const handleDeleteScanCenter = (scanCenter: ScanCenter) => {
    // console.log(scanCenter);
  };

  const handleScanCenterFormSuccess = (scanCenter: ScanCenter) => {
    setShowScanCenterForm(false);
    const scanCenterIndex = scanCenters.findIndex(
      (currentScanCenter) => scanCenter.id === currentScanCenter.id
    );
    if (scanCenterIndex >= 0) {
      scanCenters[scanCenterIndex] = scanCenter;
    } else {
      scanCenters.unshift(scanCenter);
    }
    setScanCenters([...scanCenters]);
  };

  useEffect(() => {
    setLoading(true);
    ScanCenterService.fetchScanCenters(
      (scanCenters: ScanCenter[]) => {
        setScanCenters(scanCenters);
      },
      () => {},
      () => {
        setLoading(false);
      }
    );
  }, []);

  const columns: any = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
  ];
  if (adminType === AdminTypeEnum.TELERAD_ADMIN) {
    columns.push({
      title: "Action",
      key: "action",
      render: (text: string, scanCenter: ScanCenter) => {
        return (
          <div className="scan-center-list_actions">
            <EditOutlined
              onClick={() => {
                setShowScanCenterForm(true);
                setActiveScanCenter(scanCenter);
              }}
            />
            {/* Commented for future use -- Krishna */}
            {/* <Popconfirm
              title="Are you sure to delete this Scan center?"
              placement="left"
              onConfirm={() => {
                handleDeleteScanCenter(scanCenter);
              }}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined />
            </Popconfirm> 
            <Tooltip title="View summary">
              <Link
                to={generatePath(AppRoutes.SCAN_CENTER_SUMMARY, {
                  scanCenterId: scanCenter?.id,
                })}
              >
                <FileTextOutlined />
              </Link>
            </Tooltip>*/}
            {/* Commented for future use -- Krishna */}
          </div>
        );
      },
      width: 150,
    });
  }

  return (
    <div className="scan-center-list">
      <AppCard>
        <h2>
          Scan Centers
          {adminType === AdminTypeEnum.TELERAD_ADMIN && (
            <Button
              type="primary"
              className="float-right"
              onClick={handleAddScanCenter}
            >
              <PlusOutlined />
              Add Scan center
            </Button>
          )}
        </h2>
        {loading ? (
          <AppLoader loading={loading} />
        ) : (
          <Table dataSource={scanCenters} columns={columns} />
        )}
      </AppCard>
      <Modal
        className="primary-modal"
        footer=""
        keyboard={false}
        maskClosable={false}
        destroyOnClose
        visible={showScanCenterForm}
        onCancel={handleCloseScanCenterForm}
      >
        {activeScanCenter && (
          <ScanCenterForm
            onSuccess={handleScanCenterFormSuccess}
            scanCenter={activeScanCenter}
          />
        )}
      </Modal>
    </div>
  );
}

export default AuthContainer(ScanCenterList);
